import { render, staticRenderFns } from "./TopicInfo.vue?vue&type=template&id=dcfd095e&scoped=true&"
import script from "./TopicInfo.vue?vue&type=script&lang=js&"
export * from "./TopicInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcfd095e",
  null
  
)

export default component.exports